// 2026-09-22：集中维护平台和分店管理功能用途，供顶部标题区展示，不参与菜单生成或权限判断。
export const adminFunctionDescriptions: Readonly<Record<string, string>> = Object.freeze({
  '/platform': '管理机构资料、账号、角色及入驻商家。',
  '/platform/platforminfo': '维护机构资料，配置客户端首页与购买会员页的文字、图片、按钮、区块和样式，以及支付、物流信息。',
  '/platform/wechatpay': '填写商户资料并办理微信支付开通。',
  '/platform/feedback': '查看客户意见与建议，回复并跟进处理情况。',
  '/platform/defaultFunctions': '设置新店默认角色及可使用的管理功能。',
  '/platform/orgrights': '按客户类型配置VIP角色、功能和价格；3.0会员独立管理旧会员的功能与权益。',
  '/platform/myaccount': '查看账户资金、可提现额度及收支明细。',
  '/platform/datainit': '管理新店初始化时使用的商品与基础资料。',
  '/platform/templatedetails': '维护初始化商品模板的图片、版型文件和尺码资料。',
  '/platform/branchlist': '查询机构层级，管理商家资料、会员及经营状态。',
  '/platform/fabriclist': '查询并管理面辅料商家的资料、会员及经营状态。',
  '/platform/designers': '查询并管理服装设计师的资料、会员及经营状态。',
  '/platform/manufacturers': '查询并管理成衣生产厂家的资料、会员及经营状态。',
  '/platform/accounts': '管理后台账号、所属角色及消息接收设置。',
  '/platform/rights': '维护管理角色并分配各角色可使用的功能。',
  '/platform/orgdetails': '查看和维护机构的基础资料及业务信息。',
  '/platform/icons': '查看可用图标，便于识别不同功能。',

  '/customers': '管理客户资料、会员服务和优惠券。',
  '/customers/customers': '查询客户资料，管理会员、续期及客户服务。',
  '/customers/levels': '在VIP角色总控中统一维护会员角色和权益。',
  '/customers/notes': '设置优惠券规则、适用人群与有效期，管理发放和使用。',
  '/customers/timeextention': '审核会员续期申请，核对续期时长和付款信息。',

  '/products': '维护商品资料，管理上架、引用与共享。',
  '/products/bokes': '维护版型资料与文件，管理审核、上架及售卖。',
  '/products/upsharedProducts': '管理分店在平台售卖的商品及上架状态。',
  '/products/parentSharedprds': '查看平台商品，管理本店引用和自动引用设置。',
  '/products/upshare': '查看分店商品，管理提交平台售卖与上架状态。',
  '/products/cloths': '维护成衣款式、尺码和价格，管理现货、预售与定制。',
  '/products/branchProducts': '维护本店版型资料及售卖设置。',
  '/products/fabrics': '维护面料资料、规格与价格，管理审核和上架。',
  '/products/binding': '为版型和成衣批量关联面料与饰品。',
  '/products/accessories': '维护辅料资料、规格与价格，管理审核和上架。',
  '/products/accessoriesDetails': '查看和维护辅料的图片、规格及售卖资料。',
  '/products/decoration': '维护饰品资料、规格与价格，管理审核和上架。',
  '/products/decorationDetails': '查看和维护饰品的图片、规格及售卖资料。',
  '/products/accessoryDetails': '查看和维护辅料的图片、规格及售卖资料。',
  '/products/sharingFromOther': '查看分店共享商品，管理本店展示和平台售卖状态。',
  '/products/fabricDetails': '查看和维护面料的图片、规格及售卖资料。',
  '/products/clothDetails': '查看和维护成衣的图片、尺码及售卖资料。',
  '/products/productDetails': '查看和维护版型的图片、文件、尺码及售卖资料。',

  '/audited': '处理商品审核、引用和共享申请。',
  '/audited/bokes': '核对版型资料，处理版型发布审核。',
  '/audited/cloths': '核对成衣定制资料，处理定制商品审核。',
  '/audited/retailCloths': '核对成衣现货资料，处理现货商品审核。',
  '/audited/decorations': '核对饰品资料，处理饰品发布审核。',
  '/audited/upShare': '核对分店商品，处理平台售卖申请。',
  '/audited/fabrics': '核对面料资料，处理面料发布审核。',
  '/audited/accessories': '核对辅料资料，处理辅料发布审核。',
  '/audited/settings': '设置各类商品的审核人员和审核顺序。',
  '/audited/ref': '查看并处理版型引用申请。',
  '/audited/shared': '查看并处理版型共享申请。',

  '/orders': '查询各类订单并跟进付款、制作和交付进度。',
  '/orders/bokes': '查询电子版型订单，查看付款及文件交付情况。',
  '/orders/autoscaleOrders': '查询智能量体订单，查看量体资料和处理进度。',
  '/orders/cloths': '处理成衣现货与预售订单，跟进付款、发货和售后。',
  '/orders/upgration': '查询会员购买和升级订单，跟进付款与权益开通。',
  '/orders/takeorders': '查看成衣订单需求，跟进接单与制作安排。',
  '/orders/decoration': '处理饰品订单，跟进付款、发货和售后。',
  '/orders/fabrics': '处理面料订单，跟进付款、发货和售后。',
  '/orders/accessories': '处理辅料订单，跟进付款、发货和售后。',
  '/orders/physicalBokes': '查询纸质版型订单，跟进打印、发货和售后。',
  '/orders/physicalPrinting': '处理纸质版型打印任务，跟进打印与交付进度。',
  '/orders/tailored': '查询量体订单，查看客户需求与订单处理情况。',
  '/orders/tailoredBokes': '处理来图制版需求，跟进接单、制版和交付。',
  '/orders/tailoredCloths': '处理成衣定制订单，跟进制作、发货和售后。',
  '/orders/tailoredMade': '查看客户量体资料，跟进定制版型制作和交付。',
  '/orders/videoTeching': '查询教学课程订单，查看购买与付款情况。',
  '/orderprint': '查看订单打印内容并打印业务单据。',

  '/system': '维护基础资料、内容及业务参数。',
  '/system/clothSize': '维护服装尺码资料；分店自有尺码独立管理，平台尺码作为只读参考。',
  '/system/report': '设计和维护业务单据的打印报表。',
  '/system/depositeSettings': '设置账户充值金额、赠送额度及可用状态。',
  '/system/banner': '维护站内轮播通知内容及启用状态。',
  '/system/messages': '查看系统通知与业务消息，处理相关提醒。',
  '/system/clothCategory': '维护商品类别；分店管理本店类别，平台公共类别只读。',
  '/system/clothStyle': '维护商品服装风格；分店自有风格独立管理，平台公共风格只读。',
  '/system/productUnit': '维护商品计量单位；分店自有单位独立管理，平台公共单位只读。',
  '/system/clothSizeViewer': '查看尺码项目、测量说明及具体数值。',
  '/system/clothSizeTemplate': '维护尺码模板及各量体项目的填写要求。',
  '/system/fabricCategories': '维护父级与子级服装分类；分店自有分类独立管理，平台公共分类只读。',
  '/system/videos': '维护帮助视频及分类，方便用户学习操作。',
  '/system/videoCategory': '维护视频分类，便于查找和展示相关内容。',
  '/system/settings': '查询和维护平台业务参数及功能开关。',
  // 2026-09-22：新增功能用途和演示视频配置页面的默认说明。
  '/system/functionGuides': '设置各二级功能的用途说明与演示视频，统一显示在管理端顶部。',
  '/system/operationLogs': '查询操作记录与变更明细，追溯业务处理过程。',
  '/system/course': '维护教学课程内容、视频和售卖信息。',
  '/main/icon': '查看可用图标，便于识别不同功能。',

  '/inventory': '查询商品库存及出入库记录。',
  '/inventory/storage': '查询各类商品的库存数量和库存明细。',
  '/inventory/instore': '查询商品入库记录，核对数量及入库时间。',
  '/inventory/outstore': '查询商品出库记录，核对数量及出库时间。',

  '/financial': '查看资金往来、充值和提现记录。',
  '/financial/recharge': '查询会员购买记录，核对购买金额与付款情况。',
  '/financial/depositeHistories': '维护账户充值方案、赠送金额及可用状态。',
  '/financial/depositeRecords': '查询账户充值记录，核对本金、赠额和付款状态。',
  '/financial/accountStatements': '查询账户收支流水，核对资金变动及关联业务。',
  '/financial/withdrawal': '查询并处理资金提现，跟进提现进度。'
})

const normalizedDescriptions = new Map(
  Object.entries(adminFunctionDescriptions).map(([path, description]) => [path.toLowerCase(), description])
)

// 2026-09-22：原页面说明移至共用顶部后继续区分平台源数据与分店自有数据，保留只读和同步边界。
const organizationDescriptions: Readonly<Record<string, { platform: string; branch: string }>> = {
  '/system/clothsize': {
    platform: '维护平台服装尺码，作为分店只读参考和成衣独立副本来源；分店修改不回写平台源数据。',
    branch: '四个尺码分类均可维护本店独立尺码；平台尺码只读，本店修改不影响平台或其他分店。'
  },
  '/system/clothstyle': {
    platform: '维护平台公共服装风格；分店自有数据独立管理，数据与商品优先规则同步到分店客户端和管理端。',
    branch: '维护本店服装风格；平台公共风格只读且不复制，本店数据与商品优先规则同步到客户端和管理端。'
  },
  '/system/productunit': {
    platform: '维护平台公共商品计量单位；分店自有数据独立管理，数据与商品优先规则同步到分店客户端和管理端。',
    branch: '维护本店商品计量单位；平台公共单位只读且不复制，本店数据与商品优先规则同步到客户端和管理端。'
  },
  '/system/fabriccategories': {
    platform: '维护平台公共父级与子级服装分类；分店自有数据独立管理，数据与商品优先规则同步到分店客户端和管理端。',
    branch: '维护本店父级与子级服装分类；平台公共分类只读且不复制，本店数据与商品优先规则同步到客户端和管理端。'
  }
}

// 2026-09-22：兼容菜单大小写、查询参数和详情子路径，未知功能提供用户可读的简短说明。
export const resolveAdminFunctionDescription = (path: string, title?: string, orgId?: number): string => {
  let currentPath = String(path || '').trim().split(/[?#]/, 1)[0].replace(/\/+$/, '').toLowerCase()
  while (currentPath) {
    const organizationDescription = organizationDescriptions[currentPath]
    if (organizationDescription?.platform && Number(orgId) === 1000) return organizationDescription.platform
    if (organizationDescription?.branch && Number(orgId) > 1000) return organizationDescription.branch
    const description = normalizedDescriptions.get(currentPath)
    if (description) return description
    currentPath = currentPath.slice(0, Math.max(0, currentPath.lastIndexOf('/')))
  }

  const readableTitle = String(title || '').trim()
  return /[\u3400-\u9fff]/.test(readableTitle) && !/[./\\<>]/.test(readableTitle)
    ? `查看和管理${readableTitle}相关信息。`
    : '查看相关信息，处理日常管理事务。'
}
